import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface AgeRange {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAgeRangeData {
  name: string;
  status: 'active' | 'inactive';
}

const ageService = {
  async getActiveAgeRanges(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<PaginatedResponse<AgeRange>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    
    const response = await api.get(`/age/active?${queryParams.toString()}`);
    return response.data;
  },

  async createAgeRange(ageData: CreateAgeRangeData): Promise<ApiResponse<AgeRange>> {
    const response = await api.post('/age', ageData);
    return response.data;
  }
};

export default ageService;
